const SIGNATURE_PARAMETER = "sig";
const SIGNED_PARAMETER_NAME = "ba_param";

/**
 * Mirrors Better Auth OAuth Provider 1.7.2's signed-query extraction.
 *
 * Login APIs must never receive an arbitrary page query as `oauth_query`.
 * In particular, a direct branded page such as `?client_id=demo` is not an
 * OAuth interaction and must not be submitted as though it carried a valid
 * provider signature.
 */
export function buildSignedOAuthQuery(search: string): string | undefined {
  const params = new URLSearchParams(search);
  if (!params.has(SIGNATURE_PARAMETER)) return undefined;

  const signedParameterNames = params.getAll(SIGNED_PARAMETER_NAME);
  if (signedParameterNames.length === 0) return undefined;

  const allowlist = new Set(signedParameterNames);
  const signedParams = new URLSearchParams();
  for (const [key, value] of params.entries()) {
    if (
      key === SIGNATURE_PARAMETER
      || key === SIGNED_PARAMETER_NAME
      || allowlist.has(key)
    ) {
      signedParams.append(key, value);
    }
  }
  return signedParams.toString();
}
